export const toUrlEncoded = (obj: Record<string, string | number>) =>
  Object.keys(obj)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]))
    .join("&");

export const url = (url: string, params: Record<string, string | number>) =>
  `${url}?${toUrlEncoded(params)}`;
